module.exports = __webpack_public_path__ + "static/media/itunes.09ddddbf.svg";